import React from 'react';

export default function LogoCircle(props) {
	return (
		<svg viewBox="0 0 400 400" style={{ enableBackground: 'new 0 0 400 400' }} {...props}>
			<linearGradient
				id="logo-grad-1"
				gradientUnits="userSpaceOnUse"
				x1="167.8054"
				y1="231.3387"
				x2="167.8054"
				y2="232.7837"
				gradientTransform="matrix(322.5 0 0 -397.5 -53878.4961 92446.5)">
				<stop offset="0" stopColor="#2363AE" />
				<stop offset="1" stopColor="#9258C8" />
			</linearGradient>
			<path
				className="logo-circle-a"
				d="M77.5,357.5l69.7-70.2l-22.6-22.8c-33.8-39.5-32.1-99,5.1-136.5
	c39-39.2,102.2-39.2,141.2,0s39,102.8,0,142l-17.6,17.8l35.3,35.5l17.6-17.8c58.5-58.8,58.5-154.2,0-213
	c-22.6-22.8-50.7-36.7-80-41.9V0c42.2,5.5,82.9,24.6,115.3,57.1c78,78.4,78,205.6,0,284C269.4,413.7,155.8,419.2,77.5,357.5z"
				fill="url(#logo-grad-1)"
			/>

			<linearGradient
				id="logo-grad-2"
				gradientUnits="userSpaceOnUse"
				x1="167.7944"
				y1="231.7626"
				x2="166.7594"
				y2="232.743"
				gradientTransform="matrix(175 0 0 -320 -29176 74464)">
				<stop offset="0" stopColor="#2363AE" />
				<stop offset="1" stopColor="#A46DD7" />
			</linearGradient>
			<path
				className="logo-circle-b"
				d="M41.5,320c-60.4-78.2-54.8-191.2,16.8-263C91,24.2,132.3,5.2,175,0v50.4
	c-29.9,4.8-58.5,18.8-81.6,41.9C41.3,144.6,35.8,225.9,77,284.3L41.5,320z"
				fill="url(#logo-grad-2)"
				fillOpacity="0.7"
			/>
		</svg>
	);
}
